export const NotFoundSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 535 226">
        <g fill="none" fillRule="evenodd" transform="translate(1)">
            <path
                fill="#F2F2F2"
                fillRule="nonzero"
                d="M80.352131,154 C80.7566078,152.546998 80.7881091,150.970484 80.3464608,149.413606 C79.4600141,146.293515 76.9399097,144.090576 73.9863474,143.467318 C74.0953419,143.052446 74.1583445,142.618572 74.1583445,142.168864 C74.1583445,139.350268 71.8858404,137.065621 69.0822243,137.065621 C67.4926685,137.065621 66.0751097,137.80099 65.1439312,138.950597 C62.3447253,134.036739 56.6927612,131.170638 50.8265883,132.213202 C43.841489,133.454018 39.0287197,139.796176 39.5081695,146.755258 C39.0690413,146.636814 38.6078622,146.569041 38.1290424,146.569041 C35.2964451,146.569041 33,148.782114 33,151.512035 C33,152.420319 33.2583107,153.269065 33.7024791,154 L80.352131,154 Z"
                opacity=".508"
            />
            <circle cx="328.5" cy="91" r="80" fill="#F2F2F2" opacity=".51" />
            <g transform="translate(81.634 24)">
                <polygon
                    fill="#FFF"
                    stroke="#265C7F"
                    strokeWidth="2"
                    points="148.5 0 297 201 0 201"
                />
                <polyline
                    fill="#FFF"
                    stroke="#265C7F"
                    strokeWidth="2"
                    points="230.854 140.873 289.433 61 392.866 201 186.498 201"
                />
                <path
                    fill="#EFF4F7"
                    d="M148.5,200.048862 L148.5,1.5732556 L240.417591,126.047202 L230.085851,140.230214 L289.657,186.993256 L289.427314,62.6653665 L390.88434,200.048862 L148.5,200.048862 Z"
                />
                <polygon
                    fill="#D1DFE7"
                    fillRule="nonzero"
                    style={{ mixBlendMode: 'multiply' }}
                    points="76.837 98.768 148.5 1.573 225.199 105.455 176.262 66.793 167.274 69.5 162.154 53.514 148.5 76.102 138.345 44.115"
                />
                <polygon
                    fill="#D1DFE7"
                    fillRule="nonzero"
                    style={{ mixBlendMode: 'multiply' }}
                    points="231.79 100.811 259.946 62.665 317.584 141.37 265.723 89.339 255.549 97.266 253.681 83.303"
                    transform="matrix(-1 0 0 1 549.374 0)"
                />
            </g>
            <g transform="translate(28.5 124)">
                <polygon
                    fill="#FFF"
                    stroke="#265C7F"
                    strokeWidth="2"
                    points="36.54 57.623 84.795 0 170 101 0 101"
                    transform="matrix(-1 0 0 1 170 0)"
                />
                <polygon
                    fill="#EFF4F7"
                    points="85.16 1.584 85.16 100.049 109.632 100.049 167.773 100.049"
                />
                <path
                    fill="#D1DFE7"
                    fillRule="nonzero"
                    d="M73.0382215,55.1037518 L117.929829,1.58350213 L130.051646,16.0589494 C122.671327,13.7794717 114.951755,16.2511019 106.892928,23.4738399 C98.8341005,30.696578 87.5491985,41.2398819 73.0382215,55.1037518 Z"
                    style={{ mixBlendMode: 'multiply' }}
                    transform="matrix(-1 0 0 1 203.09 0)"
                />
            </g>
            <g transform="translate(22.5 165.5)">
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(257)">
                    <ellipse
                        cx="14.5"
                        cy="14.668"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="14.5"
                        ry="14.668"
                        transform="matrix(-1 0 0 1 29 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M14.0232905,12.8356164 L13.8875806,58.5 M9.91356623,18.8584959 L13.7902978,24.3024923 M17.445674,15.3818018 L14.285953,19.819931"
                        transform="matrix(-1 0 0 1 28.014 0)"
                    />
                </g>
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(108)">
                    <ellipse
                        cx="14.5"
                        cy="14.668"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="14.5"
                        ry="14.668"
                        transform="matrix(-1 0 0 1 29 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M14.0232905,12.8356164 L13.8875806,58.5 M9.91356623,18.8584959 L13.7902978,24.3024923 M17.445674,15.3818018 L14.285953,19.819931"
                        transform="matrix(-1 0 0 1 28.014 0)"
                    />
                </g>
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(397.5 1)">
                    <ellipse
                        cx="14.5"
                        cy="14.668"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="14.5"
                        ry="14.668"
                        transform="matrix(-1 0 0 1 29 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M14.0232905,12.8356164 L13.8875806,58.5 M9.91356623,18.8584959 L13.7902978,24.3024923 M17.445674,15.3818018 L14.285953,19.819931"
                        transform="matrix(-1 0 0 1 28.014 0)"
                    />
                </g>
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(135 19)">
                    <ellipse
                        cx="11.5"
                        cy="11.633"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="11.5"
                        ry="11.633"
                        transform="matrix(-1 0 0 1 23 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M11.0232905,8.83561644 L11.285953,40.0488618 M6.91356623,14.8584959 L10.7902978,20.3024923 M14.445674,11.3818018 L11.285953,15.819931"
                        transform="matrix(-1 0 0 1 22.014 0)"
                    />
                </g>
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(431 19)">
                    <ellipse
                        cx="11.5"
                        cy="11.633"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="11.5"
                        ry="11.633"
                        transform="matrix(-1 0 0 1 23 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M11.0232905,8.83561644 L11.285953,40.0488618 M6.91356623,14.8584959 L10.7902978,20.3024923 M14.445674,11.3818018 L11.285953,15.819931"
                        transform="matrix(-1 0 0 1 22.014 0)"
                    />
                </g>
                <g stroke="#265C7F" strokeWidth="1.3" transform="translate(0 11)">
                    <ellipse
                        cx="13"
                        cy="13.151"
                        fill="#FFF"
                        fillRule="nonzero"
                        rx="13"
                        ry="13.151"
                        transform="matrix(-1 0 0 1 26 0)"
                    />
                    <path
                        strokeLinecap="round"
                        d="M13.0210638,11.8356164 L12.8853539,48 M8.91133952,17.8584959 L12.7880711,23.3024923 M16.4434472,14.3818018 L13.2837263,18.819931"
                        transform="matrix(-1 0 0 1 26.012 0)"
                    />
                </g>
                <path
                    fill="#F2F2F2"
                    fillRule="nonzero"
                    d="M305.142857,18.8761062 C305.77404,18.8761062 306.285714,19.351556 306.285714,19.9380531 C306.285714,20.5245502 305.77404,21 305.142857,21 C304.511675,21 304,20.5245502 304,19.9380531 C304,19.351556 304.511675,18.8761062 305.142857,18.8761062 Z M309.047619,19.0530973 C309.573605,19.0530973 310,19.4493055 310,19.9380531 C310,20.4268007 309.573605,20.8230088 309.047619,20.8230088 C308.521634,20.8230088 308.095238,20.4268007 308.095238,19.9380531 C308.095238,19.4493055 308.521634,19.0530973 309.047619,19.0530973 Z M307.428571,16 C308.322747,16 309.047619,16.6735539 309.047619,17.5044248 C309.047619,18.3352956 308.322747,19.0088496 307.428571,19.0088496 C306.534396,19.0088496 305.809524,18.3352956 305.809524,17.5044248 C305.809524,16.6735539 306.534396,16 307.428571,16 Z"
                    transform="rotate(39 307 18.5)"
                />
                <path
                    fill="#F2F2F2"
                    fillRule="nonzero"
                    d="M149.642857,26.8761062 C150.27404,26.8761062 150.785714,27.351556 150.785714,27.9380531 C150.785714,28.5245502 150.27404,29 149.642857,29 C149.011675,29 148.5,28.5245502 148.5,27.9380531 C148.5,27.351556 149.011675,26.8761062 149.642857,26.8761062 Z M153.547619,27.0530973 C154.073605,27.0530973 154.5,27.4493055 154.5,27.9380531 C154.5,28.4268007 154.073605,28.8230088 153.547619,28.8230088 C153.021634,28.8230088 152.595238,28.4268007 152.595238,27.9380531 C152.595238,27.4493055 153.021634,27.0530973 153.547619,27.0530973 Z M151.928571,24 C152.822747,24 153.547619,24.6735539 153.547619,25.5044248 C153.547619,26.3352956 152.822747,27.0088496 151.928571,27.0088496 C151.034396,27.0088496 150.309524,26.3352956 150.309524,25.5044248 C150.309524,24.6735539 151.034396,24 151.928571,24 Z"
                    transform="rotate(39 151.5 26.5)"
                />
                <path
                    fill="#F2F2F2"
                    fillRule="nonzero"
                    d="M265.061766,7.47755282 C265.839632,7.47755282 266.470217,8.10813768 266.470217,8.88600352 C266.470217,9.66386937 265.839632,10.2944542 265.061766,10.2944542 C264.283901,10.2944542 263.653316,9.66386937 263.653316,8.88600352 C263.653316,8.10813768 264.283901,7.47755282 265.061766,7.47755282 Z M269.873973,7.7122946 C270.522195,7.7122946 271.047682,8.23778198 271.047682,8.88600352 C271.047682,9.53422506 270.522195,10.0597124 269.873973,10.0597124 C269.225751,10.0597124 268.700264,9.53422506 268.700264,8.88600352 C268.700264,8.23778198 269.225751,7.7122946 269.873973,7.7122946 Z M267.878668,3.66299883 C268.980644,3.66299883 269.873973,4.55632738 269.873973,5.65830399 C269.873973,6.7602806 268.980644,7.65360915 267.878668,7.65360915 C266.776691,7.65360915 265.883363,6.7602806 265.883363,5.65830399 C265.883363,4.55632738 266.776691,3.66299883 267.878668,3.66299883 Z"
                    transform="rotate(-7 267.35 6.979)"
                />
                <path
                    fill="#EFF4F7"
                    fillRule="nonzero"
                    d="M415.333333,10.4513274 C416.069713,10.4513274 416.666667,11.0218672 416.666667,11.7256637 C416.666667,12.4294602 416.069713,13 415.333333,13 C414.596954,13 414,12.4294602 414,11.7256637 C414,11.0218672 414.596954,10.4513274 415.333333,10.4513274 Z M419.888889,10.6637168 C420.502539,10.6637168 421,11.1391666 421,11.7256637 C421,12.3121608 420.502539,12.7876106 419.888889,12.7876106 C419.275239,12.7876106 418.777778,12.3121608 418.777778,11.7256637 C418.777778,11.1391666 419.275239,10.6637168 419.888889,10.6637168 Z M418,7 C419.043205,7 419.888889,7.8082647 419.888889,8.80530973 C419.888889,9.80235477 419.043205,10.6106195 418,10.6106195 C416.956795,10.6106195 416.111111,9.80235477 416.111111,8.80530973 C416.111111,7.8082647 416.956795,7 418,7 Z"
                    transform="rotate(-27 417.5 10)"
                />
                <path
                    fill="#EFF4F7"
                    fillRule="nonzero"
                    d="M4.56176643,19.4775528 C5.33963228,19.4775528 5.97021714,20.1081377 5.97021714,20.8860035 C5.97021714,21.6638694 5.33963228,22.2944542 4.56176643,22.2944542 C3.78390059,22.2944542 3.15331573,21.6638694 3.15331573,20.8860035 C3.15331573,20.1081377 3.78390059,19.4775528 4.56176643,19.4775528 Z M9.373973,19.7122946 C10.0221945,19.7122946 10.5476819,20.237782 10.5476819,20.8860035 C10.5476819,21.5342251 10.0221945,22.0597124 9.373973,22.0597124 C8.72575147,22.0597124 8.20026408,21.5342251 8.20026408,20.8860035 C8.20026408,20.237782 8.72575147,19.7122946 9.373973,19.7122946 Z M7.37866784,15.6629988 C8.48064445,15.6629988 9.373973,16.5563274 9.373973,17.658304 C9.373973,18.7602806 8.48064445,19.6536092 7.37866784,19.6536092 C6.27669123,19.6536092 5.38336268,18.7602806 5.38336268,17.658304 C5.38336268,16.5563274 6.27669123,15.6629988 7.37866784,15.6629988 Z"
                    transform="rotate(-35 6.85 18.979)"
                />
            </g>
            <path
                stroke="#265C7F"
                strokeLinecap="round"
                strokeWidth="2"
                d="M0,225 C0,225 17.048692,225 161.534743,225 C181.038296,225 355.49397,225 383.788132,225 C425.1464,225 464.550356,225 502,225"
            />
            <path
                fill="#F2F2F2"
                fillRule="nonzero"
                d="M189.91272,40 C190.667932,37.358178 190.726749,34.4917895 189.902133,31.6611014 C188.247019,25.988209 183.54165,21.9828659 178.026956,20.8496693 C178.230464,20.0953566 178.348098,19.3064952 178.348098,18.4888432 C178.348098,13.364123 174.105031,9.21022066 168.870307,9.21022066 C165.902395,9.21022066 163.255624,10.5472544 161.51699,12.6374492 C156.290501,3.70316183 145.737533,-1.50793001 134.784609,0.387640633 C121.7425,2.64366912 112.756421,14.1748653 113.651617,26.8277418 C112.831707,26.6123884 111.970624,26.4891648 111.076604,26.4891648 C105.787768,26.4891648 101.5,30.5129338 101.5,35.4764268 C101.5,37.1278535 101.9823,38.6710276 102.811622,40 L189.91272,40 Z"
                opacity=".508"
                transform="matrix(-1 0 0 1 292 0)"
            />
            <path
                fill="#F2F2F2"
                fillRule="nonzero"
                d="M532.91272,143 C533.667932,140.358178 533.726749,137.49179 532.902133,134.661101 C531.247019,128.988209 526.54165,124.982866 521.026956,123.849669 C521.230464,123.095357 521.348098,122.306495 521.348098,121.488843 C521.348098,116.364123 517.105031,112.210221 511.870307,112.210221 C508.902395,112.210221 506.255624,113.547254 504.51699,115.637449 C499.290501,106.703162 488.737533,101.49207 477.784609,103.387641 C464.7425,105.643669 455.756421,117.174865 456.651617,129.827742 C455.831707,129.612388 454.970624,129.489165 454.076604,129.489165 C448.787768,129.489165 444.5,133.512934 444.5,138.476427 C444.5,140.127853 444.9823,141.671028 445.811622,143 L532.91272,143 Z"
                opacity=".51"
            />
        </g>
    </svg>
);
